import {getStoredAuthToken, removeStoredAuthToken} from './authToken'

export const checkLogin = () => {
    return typeof getStoredAuthToken() === 'string' ;
}

export const logout = () => {
    removeStoredAuthToken();
    window.location.href = "/";
}
